import React from 'react';
import { useAuth0 } from '../lib/keycloak-auth0-shim';
import { AuthProvider } from './AuthContext';

export const AuthContextWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isKeycloakConfigured = !!(process.env.REACT_APP_KEYCLOAK_URL);

  const auth0Data = useAuth0();
  const auth0 = isKeycloakConfigured ? auth0Data : null;

  return <AuthProvider auth0={auth0}>{children}</AuthProvider>;
};
